var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { compose, graphql, Separator } from "@atlassiansox/microscopekit";
import Select from "@atlaskit/select";
import warGameTemplatesByCategoryQuery from "../../graphql/predefined-templates.query.graphql";
import { WargameCategory } from "../../../__generated__/graphql-global-types";
import { lifecycle } from "recompose";
import { Radio } from "@atlaskit/radio";
import { LabelWithHelperText } from "../LabelWithHelperText";
import { useSendScreenEvent } from "../../analytics";
var SecondFormComponent = function (props) {
    var predefinedWargameTemplates = props
        .predefinedTemplatesData.warGameTemplatesByCategory
        ? props.predefinedTemplatesData.warGameTemplatesByCategory
        : [];
    var templateOptions = predefinedWargameTemplates === null || predefinedWargameTemplates === void 0 ? void 0 : predefinedWargameTemplates.map(function (wargameTemplate) {
        var tmpOption = {
            value: wargameTemplate.id,
            label: wargameTemplate.name
        };
        return tmpOption;
    });
    var _a = __read(useState(templateOptions.find(function (_a) {
        var value = _a.value;
        return value === props.wargameTemplate.wargameParent;
    })), 2), selectedTemplateOption = _a[0], setSelectedTemplateOption = _a[1];
    var _b = __read(useState(props.wargameTemplate.category ? props.wargameTemplate.category : ""), 2), category = _b[0], setCategory = _b[1];
    useEffect(function () {
        props.setFormValid(isFormValid());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTemplateOption, category]);
    useSendScreenEvent("createWargamePlanTemplateSelectionStep");
    var isFormValid = function () {
        return (category === WargameCategory.userdefined ||
            (category === WargameCategory.default && selectedTemplateOption != null));
    };
    return (React.createElement("div", null,
        React.createElement("h4", null, "Choose Template for Wargame"),
        React.createElement(Separator, null),
        React.createElement("div", null,
            React.createElement(Radio, { isChecked: category === WargameCategory.default, onChange: function (event) {
                    setCategory(event.target.value);
                    props.wargameTemplate.category = WargameCategory.default;
                }, name: "category", value: WargameCategory.default, label: React.createElement(LabelWithHelperText, { helperText: "Select a template from pre-defined templates. Useful for a new user to get started with the wargames", label: "Pre-defined template" }) }),
            React.createElement(Separator, null),
            React.createElement(Select, { value: selectedTemplateOption, placeholder: "Choose Template from the list", isLoading: props.predefinedTemplatesData.loading, menuPortalTarget: document.body, menuPosition: "fixed", isDisabled: category === WargameCategory.userdefined, spacing: "default", options: templateOptions, onChange: function (selectedOption) {
                    setSelectedTemplateOption(selectedOption);
                    props.wargameTemplate.wargameParent = selectedOption.value;
                } })),
        React.createElement(Separator, null),
        React.createElement("div", null,
            React.createElement(Radio, { isChecked: category === WargameCategory.userdefined, onChange: function (event) {
                    setCategory(event.target.value);
                    props.wargameTemplate.category = WargameCategory.userdefined;
                }, name: "category", value: WargameCategory.userdefined, label: React.createElement(LabelWithHelperText, { helperText: "Create your own wargame plan specific to your use cases ", label: "User-defined template" }) }))));
};
export var SecondForm = compose(graphql(warGameTemplatesByCategoryQuery, {
    name: "predefinedTemplatesData",
    options: function () { return ({
        query: warGameTemplatesByCategoryQuery,
        variables: { category: WargameCategory.default }
    }); }
}), lifecycle({
    componentDidMount: function () {
        if (!this.props.predefinedTemplatesData.loading) {
            this.props.predefinedTemplatesData.refetch();
        }
    }
}))(SecondFormComponent);
